import React, { useEffect } from "react";
import PageHeader from "../components/PageHeader";
import { Link } from "react-router-dom";

const Progettazione: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Progettazione";
  }, []);

  return (
    <div className="bg-white">
      <PageHeader
        title="Progettazione"
        breadcrumb="Progettazione"
      />

      <div className="container px-4 py-16 mx-auto sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <section className="mb-12">
            <img
              className="mx-auto mb-12 w-3/4 h-auto rounded-2xl shadow-2xl"
              src="/images/produzione.gif"
              alt="Processo di produzione CO.ME.ST."
            />
            <h1 className="mb-6 text-3xl font-bold text-gray-900 sm:text-4xl">
              CO.ME.ST. S.r.l. è in grado di gestire l’intero ciclo di
              realizzazione di un progetto:
            </h1>
            <ul className="pl-5 mb-8 space-y-3 text-lg list-disc text-gray-700">
              <li>
                Condivisione con il cliente delle caratteristiche chiave di un
                prodotto o il suo studio
              </li>
              <li>Progettazione ed industrializzazione delle attrezzature</li>
              <li>Fornitura della prototipia</li>
              <li>Entrata in produzione</li>
              <li>Campionatura e fornitura in tutta Europa</li>
            </ul>
          </section>

          <section className="p-10 bg-gray-50 rounded-2xl">
            <p className="mb-6 text-xl text-gray-800">
              Il nostro ufficio tecnico con l'ausilio dei più moderni sistemi
              CAD è in grado di utilizzare i più diffusi formati di gestione
              della progettazione 3D.
            </p>
            <p className="text-xl text-gray-800">
              Un'azienda appositamente creata –{" "}
              <Link
                to="/elpa"
                className="font-bold text-indigo-600 hover:underline"
              >
                Elpa Solutions
              </Link>{" "}
              – con riconosciute capacità e dotata dei più moderni macchinari e
              sistemi per calcolare la deformazione dei metalli, provvede alla
              realizzazione degli stampi e garantisce gli interventi
              manutentivi sulle attrezzature in collaborazione con il nostro
              Ufficio Tecnico ed in diretto contatto con la produzione.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Progettazione; 